import React from "react";
import Svg, { Path, Defs, LinearGradient, Stop } from "react-native-svg";
import { uniqueId } from "lodash";
import ViewModes from "../../../reflection/header/viewModes";
import InsightsIcon from "./InsightsIcon";

export default function ReflectionSwitchViewIcon(props) {
  const gradientId = "paint0_linear_switch" + uniqueId();
  const gradientUrl = "url(#" + gradientId + ")";

  return props.viewMode == ViewModes.insights ? (
    <InsightsIcon {...props} />
  ) : props.viewMode == ViewModes.tableView ? (
    <Svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.77679 3.25H3.59821C3.4059 3.25 3.25 3.4059 3.25 3.59821V7.77679C3.25 7.9691 3.4059 8.125 3.59821 8.125H7.77679C7.9691 8.125 8.125 7.9691 8.125 7.77679V3.59821C8.125 3.4059 7.9691 3.25 7.77679 3.25ZM15.0893 3.25H10.9107C10.7184 3.25 10.5625 3.4059 10.5625 3.59821V7.77679C10.5625 7.9691 10.7184 8.125 10.9107 8.125H15.0893C15.2816 8.125 15.4375 7.9691 15.4375 7.77679V3.59821C15.4375 3.4059 15.2816 3.25 15.0893 3.25ZM18.2232 3.25H22.4018C22.5941 3.25 22.75 3.4059 22.75 3.59821V7.77679C22.75 7.9691 22.5941 8.125 22.4018 8.125H18.2232C18.0309 8.125 17.875 7.9691 17.875 7.77679V3.59821C17.875 3.4059 18.0309 3.25 18.2232 3.25ZM7.77679 10.5625H3.59821C3.4059 10.5625 3.25 10.7184 3.25 10.9107V15.0893C3.25 15.2816 3.4059 15.4375 3.59821 15.4375H7.77679C7.9691 15.4375 8.125 15.2816 8.125 15.0893V10.9107C8.125 10.7184 7.9691 10.5625 7.77679 10.5625ZM10.9107 10.5625H15.0893C15.2816 10.5625 15.4375 10.7184 15.4375 10.9107V15.0893C15.4375 15.2816 15.2816 15.4375 15.0893 15.4375H10.9107C10.7184 15.4375 10.5625 15.2816 10.5625 15.0893V10.9107C10.5625 10.7184 10.7184 10.5625 10.9107 10.5625ZM22.4018 10.5625H18.2232C18.0309 10.5625 17.875 10.7184 17.875 10.9107V15.0893C17.875 15.2816 18.0309 15.4375 18.2232 15.4375H22.4018C22.5941 15.4375 22.75 15.2816 22.75 15.0893V10.9107C22.75 10.7184 22.5941 10.5625 22.4018 10.5625ZM3.59821 17.875H7.77679C7.9691 17.875 8.125 18.0309 8.125 18.2232V22.4018C8.125 22.5941 7.9691 22.75 7.77679 22.75H3.59821C3.4059 22.75 3.25 22.5941 3.25 22.4018V18.2232C3.25 18.0309 3.4059 17.875 3.59821 17.875ZM15.0893 17.875H10.9107C10.7184 17.875 10.5625 18.0309 10.5625 18.2232V22.4018C10.5625 22.5941 10.7184 22.75 10.9107 22.75H15.0893C15.2816 22.75 15.4375 22.5941 15.4375 22.4018V18.2232C15.4375 18.0309 15.2816 17.875 15.0893 17.875ZM18.2232 17.875H22.4018C22.5941 17.875 22.75 18.0309 22.75 18.2232V22.4018C22.75 22.5941 22.5941 22.75 22.4018 22.75H18.2232C18.0309 22.75 17.875 22.5941 17.875 22.4018V18.2232C17.875 18.0309 18.0309 17.875 18.2232 17.875Z"
        fill={gradientUrl}
      />
      <Defs>
        <LinearGradient
          id={gradientId}
          x1="3.25"
          y1="7.47892"
          x2="12.6368"
          y2="26.659"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#05858A" />
          <Stop offset="1" stopColor="#2AE8CB" />
        </LinearGradient>
      </Defs>
    </Svg>
  ) : (
    <Svg
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.88507 6.49827L6.4056 10.6307H0.5625C0.790029 7.88636 2.04093 5.32781 4.067 3.46277C6.09306 1.59773 8.74622 0.5625 11.5 0.5625C14.2538 0.5625 16.9069 1.59773 18.933 3.46277C20.9591 5.32781 22.21 7.88636 22.4375 10.6307H16.0764C15.9184 10.6308 15.7632 10.6716 15.6257 10.7494C15.4883 10.8272 15.3733 10.9392 15.292 11.0746L13.4953 14.0694L10.5197 6.63007C10.4565 6.47173 10.3503 6.3342 10.2131 6.23298C10.076 6.13176 9.91322 6.07086 9.74328 6.05716C9.57335 6.04346 9.40296 6.07749 9.25132 6.15543C9.09969 6.23337 8.97284 6.35211 8.88507 6.49827ZM14.1149 16.5931L16.5944 12.4606H22.4375C22.21 15.205 20.9591 17.7636 18.933 19.6286C16.9069 21.4936 14.2538 22.5289 11.5 22.5289C8.74622 22.5289 6.09306 21.4936 4.067 19.6286C2.04093 17.7636 0.790029 15.205 0.5625 12.4606H6.92364C7.08157 12.4606 7.23681 12.4197 7.37426 12.3419C7.51171 12.2642 7.62669 12.1521 7.70803 12.0167L9.50471 9.02197L12.4803 16.464C12.5435 16.6225 12.6498 16.7601 12.7871 16.8613C12.9244 16.9626 13.0873 17.0234 13.2573 17.037H13.3305C13.4885 17.037 13.6437 16.9961 13.7812 16.9183C13.9186 16.8405 14.0336 16.7285 14.1149 16.5931Z"
        fill={gradientUrl}
      />
      <Defs>
        <LinearGradient
          id={gradientId}
          x1="0.562499"
          y1="5.32629"
          x2="11.1636"
          y2="26.8974"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#05858A" />
          <Stop offset="1" stopColor="#2AE8CB" />
        </LinearGradient>
      </Defs>
    </Svg>
  );
}
